import { render } from "./AnaliticoIntegracao.vue?vue&type=template&id=428ad53f"
import script from "./AnaliticoIntegracao.vue?vue&type=script&lang=js"
export * from "./AnaliticoIntegracao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__